<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>Jordflytning frontend deployment test ({{ environment }}).</p>
    <button type="button" @click="checkApi">Check API</button>
    <p role="status">{{ status }}</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: { msg: String },
  data() {
    return { apiBaseUrl: '/api', environment: 'local', status: 'API check has not run.' }
  },
  async mounted() {
    try {
      const response = await fetch('/app-settings.json')
      if (!response.ok) throw new Error('Configuration could not be loaded.')
      const settings = await response.json()
      this.apiBaseUrl = settings.apiBaseUrl
      this.environment = settings.environment.startsWith('#{') ? 'local' : settings.environment
    } catch (error) {
      this.status = error.message
    }
  },
  methods: {
    async checkApi() {
      this.status = 'Checking API...'
      try {
        const response = await fetch(`${this.apiBaseUrl}/health`)
        if (!response.ok) throw new Error(`API returned HTTP ${response.status}.`)
        const health = await response.json()
        this.status = `API status: ${health.status}`
      } catch (error) {
        this.status = error.message
      }
    }
  }
}
</script>
